/** @format */

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Switch, Typography } from "senf-atomic-design-system";
import styled from "styled-components";
import Cookies from "universal-cookie";
import Button from "../../core/button/Button";
import { useModals } from "../../molecules/modalStack/ModalProvider";

const cookies = new Cookies();

const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.palette["grey-500"]};
`;

const HeaderSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
`;

const PrivacySettings = ({ handleSetPreferences }) => {
  const { t } = useTranslation();
  const { closeModal, closeAllModals } = useModals();
  const [activeAnalytics, setActiveAnalytics] = useState(false);

  useEffect(() => {
    if (cookies.get("consent_settings") !== "all") {
      setActiveAnalytics(false);
    }
    if (cookies.get("consent_settings") === "all") {
      setActiveAnalytics(true);
    }
  }, []);

  const handleSetAnalytics = () => {
    setActiveAnalytics(!activeAnalytics);

    if (activeAnalytics === false) {
      handleSetPreferences("all");
      cookies.set("consent_settings", "all", {
        path: "/",
        maxAge: 60 * 60 * 24 * 90,
        sameSite: "none",
        secure: true,
      });
    }
    if (activeAnalytics === true) {
      handleSetPreferences("minimum");

      cookies.set("consent_settings", "minimum", {
        path: "/",
        maxAge: 60 * 60 * 24 * 90,
        sameSite: "none",
        secure: true,
      });
    }
  };

  const PreferenceItem = ({ title, name, purpose, duration }) => {
    return (
      <React.Fragment>
        <Line />
        <Typography variant="buttonBg">
          {t("cookies:cookiesConfigurator.provider")}
        </Typography>{" "}
        <Typography variant="bodyBg">{title}</Typography>
        <Typography variant="buttonBg">
          {t("cookies:cookiesConfigurator.name")}
        </Typography>{" "}
        <Typography variant="bodyBg">{name}</Typography>
        <Typography variant="buttonBg">
          {t("cookies:cookiesConfigurator.purpose")}
        </Typography>{" "}
        <Typography variant="bodyBg">{purpose}</Typography>
        <Typography variant="buttonBg">
          {t("cookies:cookiesConfigurator.duration")}
        </Typography>{" "}
        <Typography variant="bodyBg">{duration}</Typography>
      </React.Fragment>
    );
  };
  const necessaryItems = [
    {
      title: "Senf",
      name: "consent_settings",
      purpose: t("cookies:cookiesConfigurator.cookie.consent_settings"),
      duration: `3 ${t("global:months")}`,
    },
    {
      title: "Senf",
      name: "language",
      purpose: t("cookies:cookiesConfigurator.cookie.language"),
      duration: `3 ${t("global:months")}`,
    },
  ];

  const analyticsItems = [
    {
      title: "Umami-Open-Source (self-hosted)",
      name: "N/A",
      purpose: t("cookies:cookiesConfigurator.cookie.umami"),
      duration: `3 ${t("months")}`,
    },
    {
      title: "Sentry",
      name: "N/A",
      purpose: t("cookies:cookiesConfigurator.cookie.sentry"),
      duration: `3 ${t("global:months")}`,
    },
  ];

  const externalItems = [
    {
      title: "Hotjar",
      name: "N/A",
      purpose: t("cookies:cookiesConfigurator.cookie.hotjar"),
      duration: `3 ${t("global:months")}`,
    },
  ];

  return (
    <div className="w-full h-full flex flex-col justify-between p-8 gap-5">
      <Box flexDirection="column" marginBottom="20px" gap="20px">
        <Typography variant="h1">
          {t("cookies:cookiesConfigurator.title")}
        </Typography>
        <Typography variant="bodybg">
          {t("cookies:cookiesConfigurator.subtitle")}
        </Typography>
      </Box>
      <HeaderSwitchWrapper style={{ pointerEvents: "none" }}>
        <Typography variant="h3">
          {t("cookies:cookiesConfigurator.necessaryCookies.title")}
        </Typography>
      </HeaderSwitchWrapper>
      <Typography variant="bodyBg">
        {t("cookies:cookiesConfigurator.necessaryCookies.subtitle")}
      </Typography>
      {necessaryItems.map(({ title, name, purpose, duration }) => {
        return (
          <PreferenceItem
            key={title}
            title={title}
            name={name}
            purpose={purpose}
            duration={duration}
          />
        );
      })}
      <br /> <br />
      <HeaderSwitchWrapper>
        <Typography variant="h3">
          {t("cookies:cookiesConfigurator.statisticsCookies.title")}
        </Typography>
        <Switch
          id="test-switch2"
          checked={activeAnalytics}
          onCheckedChange={handleSetAnalytics}
        />
      </HeaderSwitchWrapper>
      <Typography variant="bodyBg">
        {t("cookies:cookiesConfigurator.statisticsCookies.subtitle")}
      </Typography>
      {analyticsItems.map(({ title, name, purpose, duration }) => {
        return (
          <PreferenceItem
            key={title}
            title={title}
            name={name}
            purpose={purpose}
            duration={duration}
          />
        );
      })}
      <br /> <br />
      <Typography variant="h3">
        {" "}
        {t("cookies:cookiesConfigurator.thirdPartyCookies.title")}
      </Typography>
      <Typography variant="bodyBg">
        {t("cookies:cookiesConfigurator.thirdPartyCookies.subtitle")}
      </Typography>
      {externalItems.map(({ title, name, purpose, duration }) => {
        return (
          <PreferenceItem
            key={title}
            title={title}
            name={name}
            purpose={purpose}
            duration={duration}
          />
        );
      })}
      <Box
        width="100%"
        gap="10px"
        marginBlock="20px"
        justifyContent="space-between"
      >
        <Button
          text={t("global:back")}
          variant="basic"
          width="max"
          size="lg"
          onClick={() => closeModal()}
        />

        <Button
          text={t("global:save")}
          variant="primary"
          width="max"
          size="lg"
          onClick={() => {
            if (activeAnalytics) {
              handleSetPreferences("all");
            } else {
              handleSetPreferences("minimum");
            }
            closeAllModals();
          }}
        />
      </Box>
    </div>
  );
};

export default PrivacySettings;
